export { ApiClient, ApiClientError, apiClient } from './client';
export type { ApiEnvelope, ApiModel, ApiModelPrice, ApiUser, CreatedPaymentOrder, HistoryPage, LedgerEntry, PaymentOrder, PaymentType, RegistrationResult, UsageEntry, WalletSnapshot } from './types';

export { formatUnits } from '../money';

/** 仅用于以「分」计价的对象（例如支付订单金额）。 */
export function formatCents(cents: number): string {
  return (cents / 100).toFixed(2);
}
